import HashTable from '@frontend/hashtable';
import { SearchableCommand } from './searchable-command';

export class SearchableCommands {
    strs: HashTable<string, SearchableCommand>;

    constructor() {
        this.strs = new HashTable<string, SearchableCommand>();
    }

    add_command(command: SearchableCommand) {
        this.strs.setItem(command.id, command);
    }

    find_matching_string_ids(search_str: string, comparison_type: 'all' | 'matching' | 'nonmatching') {
        return this.strs.values()
            .filter(x => {
                switch (comparison_type) {
                    case 'matching':
                        return x.matches(search_str);

                    case 'nonmatching':
                        return !x.matches(search_str);

                    case 'all':
                    default:
                        return true;
                }
            }).map(x => x.id);
    }

    create_html(): string {
        return this.strs.values().map(x => x.create_html()).join('');
    }
}
